import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PATH } from '../../../assets/constants';
import {SharedModule} from "../../shared/shared.module";
import {ButtonSize, ButtonState, ButtonType} from "../../../assets/types/dtoTypes";
import {TranslateModule} from "@ngx-translate/core";
import {ButtonComponent} from "../../shared/button/button.component";

@Component({
    selector: 'app-success-registration-modal',
    templateUrl: './success-registration-modal.component.html',
    styleUrls: ['./success-registration-modal.component.scss'],
    standalone: true,
  imports: [
    SharedModule,
    TranslateModule,
    ButtonComponent
  ]
})
export class SuccessRegistrationModalComponent {
  dialogRef = inject<MatDialogRef<SuccessRegistrationModalComponent>>(MatDialogRef);
  private router = inject(Router);
  data = inject<{
    userId: string;
}>(MAT_DIALOG_DATA);

  constructor() {}


  goToProfile() {
    this.dialogRef.close();
    this.router.navigate( [ `${PATH.PROFIL}/${this.data.userId}` ] );
  }

  goToMain() {
    this.dialogRef.close();
    this.router.navigate( [ `${PATH.MAIN}/${this.data.userId}` ] );
  }

  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonState = ButtonState;
  protected readonly ButtonType = ButtonType;
}
